import "./style.less";
import type { IndicatorProps } from "./types";

export function Indicator({ color, text }: IndicatorProps) {
  return (
    <div className="Indicator-component">
      <span className="bolinha" style={{ color }}>
        ⬤
      </span>
      <span className="texto">{text}</span>
    </div>
  );
}
